import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Form } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';
import { ComplianceCategoryFormSelector, DataSensitivityFormSelector } from '@ui/tags';
export const ConfigurableFieldAccess = () => React.createElement(React.Fragment, null,
    React.createElement(SonarText, { className: 'subheading' }, COPY_SPECIFIC.DATA_SENSITIVITY),
    React.createElement(Form.Item, { name: ['monitorConfig', 'dataSensitivityLevels'] },
        React.createElement(DataSensitivityFormSelector, { mode: 'multiple', placeholder: COPY_SPECIFIC.ALL })),
    React.createElement(SonarText, { className: 'subheading' }, COPY_SPECIFIC.COMPLIANCE_CATEGORY),
    React.createElement(Form.Item, { name: ['monitorConfig', 'complianceCategories'] },
        React.createElement(ComplianceCategoryFormSelector, { includeAny: true, mode: 'multiple', placeholder: COPY_SPECIFIC.ALL })));
